import { render, staticRenderFns } from "./BillReviewer.vue?vue&type=template&id=5e6b9dca"
import script from "./BillReviewer.vue?vue&type=script&lang=js"
export * from "./BillReviewer.vue?vue&type=script&lang=js"
import style0 from "./BillReviewer.vue?vue&type=style&index=0&id=5e6b9dca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports